
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.42 3.31l1.87 2.002L7.548.753A.788.788 0 018.15.5c.243 0 .444.084.602.253.158.169.24.38.248.633a.856.856 0 01-.227.634l-4.88 5.227a.788.788 0 01-.603.253.788.788 0 01-.602-.253L.237 4.622A.907.907 0 010 3.977c0-.261.079-.476.237-.645a.808.808 0 01.59-.265.742.742 0 01.592.242z","fill":"#fff"}})])
          )
        }
      }
    